import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { appsettings } from '../shared/app.settings';
import { HttpClient } from '@angular/common/http';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Injectable()
export class CampaignService {

    constructor(private http: HttpClient) {}

    getCampaign() {
        return this.http
        .get(appsettings.rootUrl + 'tr/tr/campaign', {
            responseType: 'json'
        })
        .map(
        (campaign) => {
            return campaign;
        });
    }

}
